import { Component, OnInit, ViewChild } from '@angular/core';
import { SeleccionService } from '../../servicios/seleccion.service';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { ToolsService } from '../../recursos/tools.service';
import { configuracion } from '../../recursos/config.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { IngresoService } from '../../servicios/ingreso.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { LoaderComponent } from '../../servicios/loader/loader.component';

@Component({
  selector: 'app-usuarios-admin',
  templateUrl: './usuarios-admin.component.html',
  styleUrls: ['./usuarios-admin.component.css']
})
export class UsuariosAdminComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  public dtTrigger: Subject<any>;
  public vecUsuarios = [];

  private addCedula: string; public tituloModal: string; public vecAddUsuario = []; private accion: number;

  constructor(private tools: ToolsService, private srvSelect: SeleccionService, private srvInsert: IngresoService, private cargando: LoaderComponent,
    private modalService: NgbModal, private alerti: AlertifyService) { }

  ngOnInit() {
    this.dtOptions[0] = this.tools.OpcionesTabla(10);
    this.dtTrigger = new Subject();
    this.cargarUsuarios(1);
  }
  //FUNCION QUE CARGA TODOS LOS USUARIOS REGISTRADOS EN EL SISTEMA
  async cargarUsuarios(op) {
    this.vecUsuarios = [];
    this.cargando.abrir();
    this.reiniciarTabla();

    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionUsuarios(1, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success)
      for (let objUser of res.usuario) {
        if (op == 1) {
          if (objUser.intEstado == op)
            this.agregarUsuariosVec(objUser.intIdPersona, objUser.strCedula, objUser.strNombres, objUser.strApellidos, objUser.strCorreo,
              objUser.strTelefono, objUser.strCargo, objUser.strDependencia, objUser.intEstado == 1 ? "Activo" : "Inactivo");
        }
        else
          this.agregarUsuariosVec(objUser.intIdPersona, objUser.strCedula, objUser.strNombres, objUser.strApellidos, objUser.strCorreo,
            objUser.strTelefono, objUser.strCargo, objUser.strDependencia, objUser.intEstado == 1 ? "Activo" : "Inactivo");
      }
    this.dtTrigger.next();
    this.cargando.cerrar();
  }
  //AGREGAR LOS USUARIO A SER MOSTRADOS SEGUN EL ESTADO
  agregarUsuariosVec(dato1, dato2, dato3, dato4, dato5, dato6, dato7, dato8, dato9) {
    this.vecUsuarios.push({
      codigo: dato1, cedula: dato2, nombres: dato3, apellidos: dato4, correo: dato5, fono: dato6, cargo: dato7, dependencia: dato8, estado: dato9
    });
  }
  //FUNCION PARA ABRIL EL MODAL QUE PERMITE INGRESAR UN NUEVO USUARIO
  modalNuevoUsuario(nameMod) {
    this.tituloModal = "Agregar un usuario nuevo al sistema"; this.accion = 1;
    this.borrarDatos();
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION PARA ABRIL EL MODAL QUE PERMITE EDITAR UN NUEVO USUARIO
  modalVerUsuario(nameMod, objUsuario) {
    this.tituloModal = "Editar información del usuario"; this.accion = 2;
    this.buscarModUsuario(objUsuario);
    this.mr = this.modalService.open(nameMod);
  }
  //FUNCION QUE BUSCA UN USUARIO REGISTRADO EN EL SISTEMA DADO LA CEDULA
  async buscarModUsuario(buscar) {
    this.cargando.abrir();
    this.vecAddUsuario = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionUsuarios(2, buscar, "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.addCedula = res.usuario[0]['strCedula'];
      this.vecAddUsuario.push({
        codigo: res.usuario[0]['intIdPersona'], cedula: res.usuario[0]['strCedula'], nombres: res.usuario[0]['strNombres'],
        apellidos: res.usuario[0]['strApellidos'], correo: res.usuario[0]['strCorreo'], fono: res.usuario[0]['strTelefono'],
        cargo: res.usuario[0]['strCargo'], dependencia: res.usuario[0]['strDependencia'], estado: res.usuario[0]['intEstado']
      });
    }
    else
      this.borrarDatos();
    this.cargando.cerrar();
  }
  //FUNCION QUE BUSCA LOS DATOS DE UNA PERSONA EN LA CENTRALIZADA
  buscarUsuario() {
    var personal: string = "";
    //FUNCION QUE OBTIENE EL CARGO DE LA PERSONA
    this.srvSelect.personaCentralCargo(this.addCedula).subscribe(data => {
      if (data.success) {
        personal = data.cargo['puesto'];
      }
    });
    //FUNCION QUE OBTIENE LA INFORMACION DE UNA PERSONA DE LA CENTRALIZADA
    this.srvSelect.personaCentralDocumento(this.addCedula).subscribe(data => {
      if (data.success) {
        this.vecAddUsuario = [];
        this.vecAddUsuario.push({
          codigo: data.datos['per_id'], cedula: this.addCedula, nombres: data.datos['per_nombres'],
          apellidos: data.datos['per_primerApellido'] + " " + data.datos['per_segundoApellido'], correo: data.datos['per_email'],
          fono: data.datos['per_telefonoCelular'], cargo: personal, dependencia: "", estado: 1
        });
      } else {
        this.alerti.error("El usuario no se encuentra registrado como funcionario de la ESPOCH");
      }
    });
  }
  //INSTANCIA EL VECTOR DE LA PERSONA A BUSCAR
  borrarDatos() {
    this.vecAddUsuario = [];
    this.vecAddUsuario.push({ codigo: '', cedula: "", nombres: "", apellidos: "", correo: "", fono: "", cargo: "", dependencia: "", estado: 1 });
    this.addCedula = "";
  }
  //FUNCION QUE PERMITE INGRESAR O EDITAR LOS DATOS DE UN USUARIO
  agregarUsuario() {
    this.srvInsert.ingresoGestionUsuarios(this.vecAddUsuario[0]['codigo'], this.vecAddUsuario[0]['cedula'], this.vecAddUsuario[0]['nombres'],
      this.vecAddUsuario[0]['apellidos'], this.vecAddUsuario[0]['correo'], this.vecAddUsuario[0]['fono'], this.vecAddUsuario[0]['cargo'],
      this.vecAddUsuario[0]['dependencia'], this.vecAddUsuario[0]['estado'], this.accion).subscribe(res => {
        if (res.usuario) {
          this.srvInsert.ingresoGestionAuditoria(localStorage.getItem('userAudita'), 'SUPER ADMINISTRADOR', 'ingresarGestionUsuarios()',
            'INGRESAR / EDITAR UN USUARUIO DEL SISTEMA', this.accion, 'CODIGO - ' + this.vecAddUsuario[0]['codigo'] + '; CEDULA - ' + this.vecAddUsuario[0]['cedula'] +
            '; NOMBRES - ' + this.vecAddUsuario[0]['nombres'] + '; APELLIDOS - ' + this.vecAddUsuario[0]['apellidos'] + '; CORREO - ' + this.vecAddUsuario[0]['correo'] +
            '; FONO - ' + this.vecAddUsuario[0]['fono'] + '; CARGO - ' + this.vecAddUsuario[0]['cargo'] + '; DEPENDENCIA - ' + this.vecAddUsuario[0]['dependencia'] +
            '; ESTADO - ' + this.vecAddUsuario[0]['estado'], 1).subscribe(res => { });

          this.alerti.success('El usuario ha sido agregado con éxito');
          this.cerrarModal();
          this.reiniciarTabla();
          this.cargarUsuarios(1);
        }
        else
          this.alerti.error("No se puede agregar al usuario");
      });
  }
  //FUNCION QUE ACTUALIZA LOS DATOS DE LA TABLA
  reiniciarTabla() {
    var table3 = $('#tblUsuario').DataTable({ destroy: true });
    table3.destroy();
  }
  //FUNCION QUE CIERRA EL MODAL
  cerrarModal() {
    this.mr.close();
  }
}
